import React, { useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function ForgotPasswordPage(){

const navigate=useNavigate();

const[phone,setPhone]=useState("");
const[otp,setOtp]=useState("");
const[password,setPassword]=useState("");
const[confirmPassword,setConfirmPassword]=useState("");

const[showPassword,setShowPassword]=useState(false);
const[showConfirmPassword,setShowConfirmPassword]=useState(false);

const[step,setStep]=useState(1);
const[timer,setTimer]=useState(0);

const[loading,setLoading]=useState(false);
const[error,setError]=useState("");
const[success,setSuccess]=useState("");



/* TIMER */

useEffect(()=>{

if(timer<=0)return;

const interval=setInterval(()=>{

setTimer(prev=>prev-1);

},1000);

return()=>clearInterval(interval);

},[timer]);



/* SEND OTP */

const sendOTP=async()=>{

setError("");
setSuccess("");

if(phone.length<10){

setError("Enter valid phone");

return;

}

setLoading(true);

try{

await axiosInstance.post("/forgot-password/send-otp/",{phone});

setStep(2);

setTimer(30);

setSuccess("OTP sent successfully");

}

catch(err){

setError(err.response?.data?.error||"Failed to send OTP");

}

setLoading(false);

};



/* VERIFY OTP */

const verifyOTP=async()=>{

setError("");
setSuccess("");

setLoading(true);

try{

await axiosInstance.post("/forgot-password/verify-otp/",{

phone,
otp

});

setStep(3);

setSuccess("OTP verified");

}

catch(err){

setError(err.response?.data?.error||"Invalid OTP");

}

setLoading(false);

};



/* RESET PASSWORD */

const resetPassword=async()=>{

setError("");
setSuccess("");

if(password.length<4){

setError("Password too short");

return;

}

if(password!==confirmPassword){

setError("Passwords do not match");

return;

}

setLoading(true);

try{

await axiosInstance.post("/reset-password/",{

phone,
password

});

setSuccess("Password reset successful");

setTimeout(()=>navigate("/"),1500);

}

catch(err){

setError(err.response?.data?.error);

}

setLoading(false);

};



/* RESEND */

const resendOTP=async()=>{

setError("");
setSuccess("");

setLoading(true);

try{

await axiosInstance.post("/forgot-password/send-otp/",{

phone

});

setTimer(30);

setSuccess("OTP resent");

}

catch(err){

setError(err.response?.data?.error);

}

setLoading(false);

};




return(

<div style={styles.page}>

<div style={styles.card}>

<h2 style={styles.title}>Reset Password</h2>



{/* STEP 1 */}

{step===1&&(

<>

<input

style={styles.input}

placeholder="Phone Number"

value={phone}

onChange={(e)=>setPhone(e.target.value)}

/>

<button

style={styles.button}

onClick={sendOTP}

disabled={loading}

>

{loading?"Sending...":"Send OTP"}

</button>

</>

)}




{/* STEP 2 */}

{step===2&&(

<>

<input

style={styles.input}

placeholder="Enter OTP"

value={otp}

onChange={(e)=>setOtp(e.target.value)}

/>


<button

style={styles.button}

onClick={verifyOTP}

disabled={loading}

>

Verify OTP

</button>


<button

style={styles.resend}

onClick={resendOTP}

disabled={timer>0}

>

{timer>0

?

`Resend OTP in ${timer}s`

:

"Resend OTP"

}

</button>

</>

)}




{/* STEP 3 */}

{step===3&&(

<>

<div style={{position:"relative"}}>

<input

style={styles.input}

type={showPassword?"text":"password"}

placeholder="New Password"

value={password}

onChange={(e)=>setPassword(e.target.value)}

/>

<span

style={styles.eye}

onClick={()=>setShowPassword(!showPassword)}

>

{showPassword?<FaEyeSlash/>:<FaEye/>}

</span>

</div>




<div style={{position:"relative"}}>

<input

style={styles.input}

type={showConfirmPassword?"text":"password"}

placeholder="Confirm Password"

value={confirmPassword}

onChange={(e)=>setConfirmPassword(e.target.value)}

/>

<span

style={styles.eye}

onClick={()=>setShowConfirmPassword(!showConfirmPassword)}

>

{showConfirmPassword?<FaEyeSlash/>:<FaEye/>}

</span>

</div>



<button

style={styles.button}

onClick={resetPassword}

disabled={loading}

>

Reset Password

</button>

</>

)}




{error&&<p style={styles.error}>{error}</p>}

{success&&<p style={styles.success}>{success}</p>}



</div>

</div>

);

}




/* STYLES */

const styles={

page:{

minHeight:"100vh",

display:"flex",

justifyContent:"center",

alignItems:"center",

background:"#eef2f7",

padding:20,

},

card:{

width:"100%",

maxWidth:400,

background:"#fff",

padding:30,

borderRadius:12,

boxShadow:"0 8px 25px rgba(0,0,0,0.1)",

textAlign:"center",

},

title:{

marginBottom:20,

color:"#2a7ae4",

},

input:{

width:"100%",

padding:14,

marginBottom:15,

borderRadius:8,

border:"1px solid #ccc",

fontSize:16,

},

button:{

width:"100%",

padding:14,

background:"#2a7ae4",

color:"#fff",

border:"none",

borderRadius:8,

fontSize:16,

cursor:"pointer",

marginBottom:10,

},

resend:{

width:"100%",

padding:12,

background:"#28a745",

color:"#fff",

border:"none",

borderRadius:8,

fontSize:15,

cursor:"pointer",

marginBottom:10,

},

eye:{

position:"absolute",

right:12,

top:15,

cursor:"pointer"

},

error:{

color:"red"

},

success:{

color:"green"

}

};